import {Component, Input, EventEmitter, Output} from '@angular/core';
import {Meeting} from '../../../model/meeting';


@Component({
    selector: 'app-prestation-calendar',
    templateUrl: './prestation-calendar.component.html',
    imports: [],
    styleUrls: ['./prestation-calendar.component.css']
})
export class PrestationCalendarComponent {

  @Input()
  month: number;

  @Input()
  year: number;

  @Input() over;
  @Output() overChange = new EventEmitter<any>();
  @Output() showMeeting = new EventEmitter<Meeting>();

  meetings$: Meeting[];

  today = new Date();
  todayMonth = false;

  @Input()
  set meetings(val: Meeting[]) {
    this.weeks.length = 0;
    this.meetings$ = val;
    this.buildCalendar();
  }

  name: string;

  weeks = [];

  buildCalendar(): void {
    this.todayMonth = this.today.getFullYear() === this.year && this.today.getMonth() === this.month;

    const date = new Date(this.year, this.month + 1, 0);

    this.name = date.toLocaleString('default', {month: 'long'});
    this.name = this.name.charAt(0).toUpperCase() + this.name.slice(1);

    const daysInMonth = date.getDate();

    const range = [...Array(daysInMonth).keys()].map(i => i + 1);
    this.weeks[0] = [];
    // Monday == 1
    let currentweek = 0;
    range.forEach(num => {
      const currentDay = new Date(this.year, this.month, num).getDay();
      if (this.weeks[0].length === 0) {
        let invisibleDay = 1;
        while (invisibleDay % 7 !== currentDay) {
          this.weeks[0].push({day: -1});
          invisibleDay++;
        }
      }
      this.weeks[currentweek].push({day: num, meeting: this.checkMeetingsOnDay(num)});

      if (new Date(this.year, this.month, num).getDay() === 0 && num !== daysInMonth) {
        currentweek++;
        this.weeks[currentweek] = [];
      }
    });

    while (this.weeks[currentweek].length % 7 !== 0) {
      this.weeks[currentweek].push({day: -1});
    }
  }

  checkMeetingsOnDay(day: number): any {
    const currentDate = new Date(this.year, this.month, day);
    let found;
    if (this.meetings$ !== undefined) {
      this.meetings$.forEach(m => {
        const meetingDate = new Date(m.dateStart);
        if (currentDate.getFullYear() === meetingDate.getFullYear()
          && currentDate.getMonth() === meetingDate.getMonth()
          && currentDate.getDate() === meetingDate.getDate()) {
          found = m;
        }
      });
    }
    return found;
  }

  overMeeting(m: any): void {
    this.over = m;
    this.overChange.emit(this.over);
  }

  show(meeting: any): void {
    if (meeting != null) {
      this.showMeeting.emit(meeting);
    }
  }
}
